import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Block, { BlockWrapper, BlockContent, BlockHeader } from 'UI/Elements/Block';
import DatePickerFromTo from 'containers/Forms/Partials/DatePickerFromTo';

var GraphContent = /*#__PURE__*/function (_Component) {
  _inherits(GraphContent, _Component);

  var _super = _createSuper(GraphContent);

  function GraphContent() {
    _classCallCheck(this, GraphContent);

    return _super.apply(this, arguments);
  }

  _createClass(GraphContent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "graph content"
      }, /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: 1
      }, /*#__PURE__*/React.createElement(Block, null, this.props.title ? /*#__PURE__*/React.createElement(BlockHeader, null, this.props.title) : null, /*#__PURE__*/React.createElement(BlockContent, null, this.props.children))));
    }
  }]);

  return GraphContent;
}(Component);

export default GraphContent;